import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'modules/main/redux';
import { TimestampedLocation } from '../types';

export const lastLocationSelector = createSelector(
  [(state: RootState): TimestampedLocation[] => state.location.history],
  (history): TimestampedLocation => history[0] || {},
);

export const currentCoordinatesSelector = (
  state: RootState,
): number[] | undefined => lastLocationSelector(state).coordinates;

const currentCoordinatesWithDefault = createSelector(
  [currentCoordinatesSelector],
  (coordinates): number[] => coordinates || [-1.7946464, 46.4967547],
);

export const LocationSelectors = {
  lastLocation: lastLocationSelector,
  currentCoordinates: currentCoordinatesSelector,
  currentCoordinatesWithDefault,
};
